export type Environment =
  | 'development'
  | 'test'
  | 'production'
  | 'monthly-production'
  | 'rem-daily'
  | 'kp-daily'
export interface EnvConst {
  ENVIRONMENT: Environment
  DATASET_ID: number
  FACILITY_NAME: string
  BACKEND_API_ROOT_URL: string
  CDF_PROJECT: string
  // InFieldのロケーション識別子。「機器情報 詳細」ボタンのリンク先に使う。
  // 従来は全環境で 'fh2r' (浪江FH2R) 固定だったため、川崎パイロットとREM実証棟では
  // 誤ったロケーションを開いていた。現状は従来の挙動を維持するため全環境 'fh2r' のままで、
  // 正しい値が判明した環境から順に修正すること。
  INFIELD_LOCATION: string
}
// クラスタはテナント(CDF_PROJECT)ごとに決まる。
// 新テナント(ak-namie / ak-kawasaki)のみ aw-tyo-001。
// 旧テナントは移行完了まで切り戻せるよう残している。
export const CDF_CLUSTERS: Record<string, string | undefined> = {
  'ak-h2': 'asia-northeast1-1',
  'ak-sfx': 'asia-northeast1-1',
  'ak-namie': 'aw-tyo-001',
  'ak-kawasaki': 'aw-tyo-001'
}
export const commonConst = {
  AZURE_APP_ID: '9e407f0f-d5dc-4896-942d-9e92986beafd',
  AZURE_TENANT_ID: 'e171a14d-4552-444f-ae6d-8a28cadd3bfb'
}
export const APPROVER_GROUP_ID = '7fdd8cfd-3917-435b-8d03-235e91d5e661'
